import { AuthContextProps } from "../components/auth-context";
import ChangeNumberForm from "../types/change-number";
import { getData, postData } from "./core";

export default class ChangeNumberApi {
  static unauthorizedUri = "n/internet/SetSimCard";
  static authorizedUri = "a/internet/SetSimCard";

  context: AuthContextProps;

  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get() {
    return getData({
      uri: ChangeNumberApi.unauthorizedUri,
      context: this.context,
    });
  }

  post(data: ChangeNumberForm) {
    return postData({
      uri: ChangeNumberApi.unauthorizedUri,
      context: this.context,
      data,
    });
  }
}
